<template>
  <b-row>
    <b-col v-if="isLoading">
      <Loader size="lg"></Loader>
    </b-col>
    <b-col v-else>
      <b-row v-if="item">
        <b-col>
          <button class="btn btn-warning" @click="archiveItem(item)">{{ $t('buttons.archive') }}</button>
          <router-link class="btn" :to="{name: 'EXCMUserDataSalesOpportunityUpdate', params: { id: item['@id'] }}">
            <span v-if="!mobileView">{{ $t('buttons.edit') }}</span>
            <i v-else class="far fa-edit"></i>
          </router-link>
          <!--<button class="btn btn-danger" @click="deleteItem(item)">-->
            <!--<span v-if="!mobileView">{{ $t('buttons.delete') }}</span>-->
            <!--<i v-else class="far fa-trash-alt"></i>-->
          <!--</button>-->
          <router-link v-if="prevRoute.name === 'TimetableDashboard'" :to="{ name: 'TimetableDashboard' }" class="btn btn-default float-right">
            <span v-if="!mobileView">{{$t('buttons.backToCRM')}}</span>
            <i v-else class="far fa-arrow-alt-left"></i>
          </router-link>
          <router-link v-else :to="{ name: 'EXCMUserDataSalesOpportunityList' }" class="btn btn-default float-right">
            <span v-if="!mobileView">{{$t('buttons.backToList')}}</span>
            <i v-else class="far fa-arrow-alt-left"></i>
          </router-link>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
<!--            <div class="card-header">-->
<!--              <h4 class="card-title">{{$t('views.excmuserdatasalesopportunity.show.title')}}</h4>-->
<!--            </div>-->
            <div class="card-body">
              <b-row v-if="item">
                <b-col>
                  <p class="mb-0 mt-1">
                    <span>{{$t('views.excmuserdatastatus.show.name')}}: <b>{{ item.title }}</b></span><br>
                    <span>{{$t('views.excmuserdatastatus.show.color')}}: <b><span v-b-tooltip.hover :title="item.color" :style="'color: ' + item.color" class="h6 mt-0 mb-0"><i class="fa fa-circle mr-2"></i></span></b></span><br>
                    <span>{{$t('views.excmuserdatastatus.show.description')}}: <b>{{ item.description }}</b></span>
                  </p>
                </b-col>
              </b-row>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Loader from '../../Layout/Loader'
import getId from '@/utils/getIdFromLink'

export default {
  components: {
    Loader
  },
  computed: {
    mobileView () {
      return this.$store.state.mobileView
    },
    ...mapGetters({
      deleteError: 'excmuserdatasalesopportunity/del/error',
      error: 'excmuserdatasalesopportunity/show/error',
      isLoading: 'excmuserdatasalesopportunity/show/isLoading',
      item: 'excmuserdatasalesopportunity/show/retrieved'
    })
  },

  data () {
    return {
      prevRoute: null
    }
  },

  beforeRouteEnter (to, from, next) {
    next((vm) => {
      vm.prevRoute = from
    })
  },

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  methods: {
    ...mapActions({
      del: 'excmuserdatasalesopportunity/del/del',
      reset: 'excmuserdatasalesopportunity/show/reset',
      retrieve: 'excmuserdatasalesopportunity/show/retrieve'
    }),

    getIdLink (link) {
      return getId(link)
    },

    archiveItem (item) {
      this.$Swal({
        title: this.$t('notifications.archiveTitle') + ' ' + this.$t('notifications.archiveDescription'),
        type: 'question',
        showConfirmButton: true,
        confirmButtonText: this.$t('buttons.yes'),
        showCancelButton: true,
        cancelButtonText: this.$t('buttons.cancel')
      }).then((result) => {
        if (result) {
          this.$http
            .put('api/e_x_c_m_user_data_sales_opportunities/' + this.getIdLink(this.item['@id']), {
              state: 0
            })
            .then(response => {
              this.$router.push({ name: 'EXCMUserDataSalesOpportunityList' })
              this.$Swal({ // show notification with success
                type: 'success',
                title: this.$t('notifications.update.updatedTitle'),
                showConfirmButton: false,
                timer: 2500
              })
            })
            .catch(error => {
              if (error.response.status === 400) {
                let text = ''
                for (let i in error.response.data) {
                  text += error.response.data[i] + '\n'
                }
                this.$Swal({
                  type: 'warning',
                  title: text,
                  timer: 2500
                })
              }
              console.log(error)
            })
        }
      })
    },

    deleteItem (item) {
      if (window.confirm('Are you sure you want to delete this item?')) {
        this.del(item).then(() => this.$router.push({ name: 'EXCMUserDataSalesOpportunityList' }))
      }
    }
  }
}
</script>
